import React from 'react';

/**
 * Shown in a widget's expanded view when its data query failed.
 *
 * Widgets gate their empty state on `count === 0`, and a failed query leaves count at 0 -
 * so a timeout renders as "No records found", complete with a reassuring green tick. That
 * is actively dangerous on a clinical dashboard: "No Unprinted Recall Letters Found" read
 * as nothing-to-do while the real answer was 204,770. A failure must look like a failure.
 *
 * @param {object} props
 * @param {() => void} [props.onRetry]
 * @param {string} [props.detail] - optional detail from the failed request
 * @param {string} [props.mutedColor] - matches the host widget's theme
 */
export default function WidgetDataError({ onRetry, detail, mutedColor }) {
    return (
        <div className="text-center" style={{ padding: '2rem 0' }}>
            <i className="fas fa-exclamation-triangle fa-3x mb-3" style={{ color: '#f59e0b' }} />
            <p style={{ fontWeight: 500, marginBottom: '0.25rem' }}>Unable to load this widget</p>
            <p className="text-sm" style={{ color: mutedColor }}>
                {detail || 'The request did not complete. This is not the same as having no records.'}
            </p>
            {onRetry && (
                <button type="button" className="btn btn-sm btn-link mt-2" onClick={onRetry}>
                    <i className="fas fa-redo mr-1" /> Try again
                </button>
            )}
        </div>
    );
}
